import { useMemo } from 'react';
import { EXPORT_FACEBOOK_CUSTOM_AUDIENCE_ENDPOINT } from 'api/ListsApi';
import { UseRestMutationOptions, useRestMutation } from 'utils/hooks/api';
import { useToastNotification } from 'utils/hooks/useToastNotification';
import { ApiMethod, ApiError } from 'services/api';
import { useModalsContext } from '../contexts/modals';
import { useTranslation } from './useTranslation';

export const useExportToFBCAMutation = (options?: UseRestMutationOptions) => {
  const { t } = useTranslation();
  const { hideModal: closeModal } = useModalsContext();
  const restMutation = useRestMutation(
    EXPORT_FACEBOOK_CUSTOM_AUDIENCE_ENDPOINT,
    ApiMethod.post,
    options,
  );

  const { variables = {}, isError, isSuccess, error } = restMutation;

  const positiveToastMessageParams = useMemo(() => {
    const { data = {} } = variables;
    const { customAudienceName = '', adAccount = {} } = data;
    const { adAccountId = '' } = adAccount;
    return { customAudienceName, adAccountId };
  }, [variables]);

  const negativeMessage =
    (error as ApiError)?.response?.data?.message ?? t('toast.exportToFBCANegative');

  useToastNotification({
    enabled: isError,
    negative: true,
    negativeMessage,
  });

  useToastNotification({
    enabled: isSuccess,
    onDone: closeModal,
    positive: true,
    positiveMessage: t('toast.exportToFBCAPositive', positiveToastMessageParams),
  });

  return { ...restMutation };
};
